<div *ngIf="actual" [ngClass]="{'exceeded': isExceeded() }" class="anticipated-calc">
    <span class="anticipated-text">Anticipated:</span>
    <span class="amount-text">{{ amountPrefix }}{{ calcPair.anticipated.amount }}{{ amountSuffix }}</span>
    x
    <span class="unit-cost-text">{{ unitPrefix }}{{ calcPair.anticipated.unitCost }}{{ unitSuffix }}</span>
    =
    <span class="total-text">{{ unitPrefix }}{{ calcPair.anticipated.total }}{{ unitSuffix }}</span>
</div>
<eil-unitcalc (change)="onChangeCallback(calcPair)"
              (focusin)="onFocus()"
              [(ngModel)]="boundCalc"
              [amountHeader]="amountHeader"
              [amountPrefix]="amountPrefix"
              [amountSuffix]="amountSuffix"
              [disabled]="disabled"
              [ngModelOptions]="{standalone: true}"
              [totalHeader]="totalHeader"
              [unitCostEditable]="unitCostEditable"
              [unitCostHeader]="unitCostHeader"
              [unitPrefix]="unitPrefix"
              [unitSuffix]="unitSuffix"
></eil-unitcalc>
